import axiosInstance from './axiosConfig';
import type {
  ClientNotification,
  ClientNotificationListResponse,
} from '../types/clientNotification';

export interface ClientNotificationFilters {
  page?: number;
  limit?: number;
  status?: string;
  category?: string;
}

export async function fetchClientNotifications(
  filters: ClientNotificationFilters = {}
): Promise<ClientNotificationListResponse> {
  const response = await axiosInstance.get<ClientNotificationListResponse>(
    '/api/client-notifications',
    { params: filters }
  );
  return response.data;
}

export async function fetchClientUnreadCount(): Promise<number> {
  const response = await axiosInstance.get<{ success: boolean; count: number }>(
    '/api/client-notifications/unread-count'
  );
  return response.data.count ?? 0;
}

export async function markClientNotificationRead(notificationId: string): Promise<void> {
  await axiosInstance.patch(`/api/client-notifications/${notificationId}/read`);
}

export async function markAllClientNotificationsRead(): Promise<void> {
  await axiosInstance.patch('/api/client-notifications/mark-all-read');
}

export async function deleteClientNotification(notificationId: string): Promise<void> {
  await axiosInstance.delete(`/api/client-notifications/${notificationId}`);
}

export function resolveNotificationPath(notification: ClientNotification): string {
  const deepLink = notification.metadata?.deep_link;
  if (deepLink?.startsWith('/')) return deepLink;

  switch (notification.type) {
    case 'support_message':
      return '/chat';
    case 'community_message':
    case 'community_joined':
    case 'community_member_joined':
      return notification.metadata?.community_id
        ? `/community/${notification.metadata.community_id}`
        : '/chat';
    case 'appointment_booked':
      return notification.metadata?.deep_link || '/appointments';
    case 'store_purchase':
      return '/store';
    case 'cwy_grant_approved':
    case 'cwy_grant_rejected':
    case 'cwy_deposit_confirmed':
    case 'cwy_transfer_completed':
    case 'cwy_transfer_failed':
    case 'payment_received':
      return '/profile/wallet';
    default:
      return '/';
  }
}

export type { ClientNotification };
